/* CRBN build: duplicate-submit-guard-2026-09-01 */
(()=>{"use strict";
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const money=(cents,currency='USD')=>new Intl.NumberFormat('en-US',{style:'currency',currency,minimumFractionDigits:cents%100?2:0,maximumFractionDigits:2}).format(cents/100);
const shopRoot=()=>{const root=window.Shopify?.routes?.root||'/';return root.endsWith('/')?root:`${root}/`;};
const configurationId=()=>window.crypto?.randomUUID?`crbn-${window.crypto.randomUUID()}`:`crbn-${Date.now()}-${Math.random().toString(36).slice(2,10)}`;
const selectExpressWallet=configs=>{
 const get=name=>configs.find(config=>config?.name===name);
 const ua=navigator.userAgent||'';
 const appleDevice=/iPhone|iPad|iPod|Macintosh/i.test(ua);
 const androidDevice=/Android/i.test(ua);
 if(appleDevice&&get('apple_pay'))return get('apple_pay');
 if(androidDevice&&get('google_pay'))return get('google_pay');
 return get('shop_pay')||get('google_pay')||get('apple_pay')||get('paypal')||configs[0]||null;
};

if(!customElements.get('crbn-single-wallet-checkout')){
 customElements.define('crbn-single-wallet-checkout',class extends HTMLElement{
  constructor(){
   super();
   this.walletObserver=new MutationObserver(()=>this.mountWallet());
  }
  connectedCallback(){
   this.walletObserver.observe(this,{childList:true});
   this.mountWallet();
  }
  disconnectedCallback(){this.walletObserver.disconnect();}
  mountWallet(){
   const template=this.querySelector(':scope > template[data-crbn-single-wallet-template]');
   if(!template)return;
   this.walletObserver.disconnect();
   const fragment=template.content.cloneNode(true);
   const checkout=fragment.querySelector('shopify-accelerated-checkout-cart');
   let walletName='fallback';
   if(checkout){
    try{
     const configs=JSON.parse(checkout.getAttribute('wallet-configs')||'[]');
     const selected=selectExpressWallet(configs);
     if(selected){
      checkout.setAttribute('wallet-configs',JSON.stringify([selected]));
      walletName=selected.name||'single';
     }
    }catch(_){walletName='unfiltered';}
   }
   this.replaceChildren(fragment);
   this.dataset.crbnWallet=walletName;
   queueMicrotask(()=>{if(this.isConnected)this.walletObserver.observe(this,{childList:true});});
  }
 });
}

const syncHeader=()=>document.body.classList.toggle('crbn-scrolled',window.scrollY>24);
syncHeader();
window.addEventListener('scroll',syncHeader,{passive:true});

document.querySelectorAll('[data-crbn-accordion-trigger]').forEach(trigger=>{
 const item=trigger.closest('.crbn-accordion');
 if(!item||trigger.dataset.crbnAccordionReady==='true')return;
 trigger.dataset.crbnAccordionReady='true';
 trigger.addEventListener('click',()=>{
  const open=!item.classList.contains('is-open');
  item.classList.toggle('is-open',open);
  trigger.setAttribute('aria-expanded',String(open));
 });
});

document.querySelectorAll('[data-crbn-option-accordion-trigger]').forEach(trigger=>{
 const item=trigger.closest('.crbn-option-group');
 if(!item||trigger.dataset.crbnOptionAccordionReady==='true')return;
 trigger.dataset.crbnOptionAccordionReady='true';
 trigger.addEventListener('click',()=>{
  const open=!item.classList.contains('is-open');
  item.classList.toggle('is-open',open);
  trigger.setAttribute('aria-expanded',String(open));
 });
});

document.querySelectorAll('[data-crbn-hero-title]').forEach(title=>{
 let charIndex=0;
 title.querySelectorAll('.crbn-hero-title__line').forEach(line=>{
  const text=line.textContent;
  line.textContent='';
  [...text].forEach(character=>{
   const span=document.createElement('span');
   span.className='crbn-hero-title__char';
   span.textContent=character===' '?'\u00a0':character;
   span.style.setProperty('--crbn-char-index',charIndex++);
   line.appendChild(span);
  });
 });
 title.classList.add('is-split');
 if(reduced){title.classList.add('is-visible');return;}
 requestAnimationFrame(()=>requestAnimationFrame(()=>title.classList.add('is-visible')));
});

document.querySelectorAll('.crbn-reveal-stagger').forEach(group=>{
 [...group.children].filter(item=>!item.hidden&&!(item.matches('input[type="hidden"]'))).forEach((item,index)=>item.style.setProperty('--crbn-item-delay',`${index*85}ms`));
});
const reveal=[...document.querySelectorAll('.crbn-reveal,.crbn-reveal-stagger')];
if(reduced||!('IntersectionObserver'in window)){reveal.forEach(el=>el.classList.add('is-visible'));}else{
 const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)return;entry.target.classList.add('is-visible');observer.unobserve(entry.target);}),{threshold:.1,rootMargin:'0px 0px -7%'});
 reveal.forEach((el,index)=>{el.style.setProperty('--crbn-delay',`${Math.min((index%6)*70,350)}ms`);observer.observe(el);});
}

document.querySelectorAll('[data-crbn-splide]').forEach(slider=>{
 if(!window.Splide)return;
 const autoScroll=window.splide?.Extensions?.AutoScroll;
 const instance=new window.Splide(slider,{type:autoScroll?'loop':'slide',autoWidth:true,focus:0,gap:'12px',drag:true,snap:true,rewind:!autoScroll,trimSpace:false,arrows:false,pagination:false,keyboard:'focused',speed:620,easing:'cubic-bezier(.16,1,.3,1)',autoScroll:autoScroll&&!reduced?{speed:.34,pauseOnHover:true,pauseOnFocus:true}:false,reducedMotion:{speed:0,rewindSpeed:0,autoplay:'pause'}});
 instance.mount(autoScroll?{AutoScroll:autoScroll}:{});
 const slides=[...slider.querySelectorAll('.splide__slide')];
 if(reduced||!('IntersectionObserver'in window)){slides.forEach(slide=>slide.classList.add('is-card-revealed'));return;}
 const slideObserver=new IntersectionObserver(entries=>{
  entries.filter(entry=>entry.isIntersecting&&entry.intersectionRatio>=.12).sort((a,b)=>a.boundingClientRect.left-b.boundingClientRect.left).forEach((entry,index)=>{
   entry.target.style.setProperty('--crbn-slide-delay',`${index*90}ms`);
   entry.target.classList.add('is-card-revealed');
   slideObserver.unobserve(entry.target);
  });
 },{threshold:[.12,.35]});
 slides.forEach(slide=>slideObserver.observe(slide));
});

document.querySelectorAll('[data-crbn-collection-scroll]').forEach(surface=>{
 const progress=surface.parentElement?.querySelector('[data-crbn-collection-progress]');
 let requested=false;
 const update=()=>{
  requested=false;
  if(!progress)return;
  const maxScroll=surface.scrollWidth-surface.clientWidth;
  const ratio=maxScroll>0?surface.scrollLeft/maxScroll:1;
  progress.style.transform=`scaleX(${Math.max(.04,Math.min(1,ratio))})`;
 };
 surface.addEventListener('scroll',()=>{if(requested)return;requested=true;requestAnimationFrame(update);},{passive:true});
 window.addEventListener('resize',update);

 let drag=null;
 let suppressClickUntil=0;
 const endDrag=event=>{
  if(!drag||event.pointerId!==drag.id)return;
  if(drag.axis==='x'){
   suppressClickUntil=performance.now()+350;
   surface.classList.remove('is-dragging');
   if(surface.hasPointerCapture?.(event.pointerId))surface.releasePointerCapture(event.pointerId);
  }
  drag=null;
 };
 surface.addEventListener('pointerdown',event=>{
  if(!event.isPrimary)return;
  // Touch gets its own stricter axis-lock below so iOS vertical page scroll
  // never competes with the horizontal category rail.
  if(event.pointerType==='touch')return;
  if(event.pointerType==='mouse'&&event.button!==0)return;
  drag={id:event.pointerId,x:event.clientX,y:event.clientY,left:surface.scrollLeft,axis:null};
 },{passive:true});
 surface.addEventListener('pointermove',event=>{
  if(!drag||event.pointerId!==drag.id)return;
  const dx=event.clientX-drag.x;
  const dy=event.clientY-drag.y;
  if(!drag.axis){
   if(Math.hypot(dx,dy)<8)return;
   // Favor normal page scrolling unless the gesture is clearly horizontal.
   drag.axis=Math.abs(dx)>Math.abs(dy)*1.3?'x':'y';
   if(drag.axis==='y'){
    drag=null;
    return;
   }
   surface.classList.add('is-dragging');
   surface.setPointerCapture?.(event.pointerId);
  }
  if(drag.axis!=='x')return;
  event.preventDefault();
  surface.scrollLeft=drag.left-dx;
 },{passive:false});
 surface.addEventListener('pointerup',endDrag,{passive:true});
 surface.addEventListener('pointercancel',event=>{
  if(drag&&event.pointerId===drag.id){
   surface.classList.remove('is-dragging');
   drag=null;
  }
 },{passive:true});
 surface.addEventListener('click',event=>{
  if(performance.now()>=suppressClickUntil)return;
  event.preventDefault();
  event.stopPropagation();
 },true);
 surface.addEventListener('dragstart',event=>event.preventDefault());
 update();
});

document.querySelectorAll('.crbn-gallery__media').forEach(gallery=>{
 gallery.addEventListener('dragstart',event=>event.preventDefault());
 gallery.querySelectorAll('img').forEach(image=>{image.draggable=false;});
});

document.querySelectorAll('[data-crbn-wheel-gallery]').forEach(gallery=>{
 const toggle=gallery.querySelector('[data-crbn-gallery-toggle]');
 const extras=[...gallery.querySelectorAll('[data-crbn-gallery-extra]')];
 if(!toggle||!extras.length)return;
 const label=toggle.querySelector('[data-crbn-gallery-toggle-label]');
 const icon=toggle.querySelector('b');
 toggle.addEventListener('click',()=>{
  const expanded=toggle.getAttribute('aria-expanded')==='true';
  toggle.setAttribute('aria-expanded',String(!expanded));
  extras.forEach((card,index)=>{
   card.hidden=expanded;
   if(!expanded){
    card.style.setProperty('--crbn-delay',`${index*70}ms`);
    requestAnimationFrame(()=>card.classList.add('is-visible'));
   }else{
    card.classList.remove('is-visible');
   }
  });
  if(label)label.textContent=expanded?`View ${extras.length} more wheels`:'Show fewer wheels';
  if(icon)icon.textContent=expanded?'↓':'↑';
 });
});

document.querySelectorAll('[data-crbn-configurator]').forEach(configurator=>{
 if(configurator.dataset.crbnConfiguratorReady==='true')return;
 configurator.dataset.crbnConfiguratorReady='true';
 const price=configurator.closest('.crbn-config,.crbn-product')?.querySelector('[data-crbn-price]');
 const summary=configurator.querySelector('[data-crbn-summary]');
 const summaryVehicle=configurator.querySelector('[data-crbn-summary-vehicle]');
 const summaryTotal=configurator.querySelector('[data-crbn-summary-total]');
 const selects=[...configurator.querySelectorAll('[data-crbn-option]')];
 const configRoot=configurator.closest('.crbn-config,.crbn-product');
 const previewImages=[...configRoot?.querySelectorAll('[data-crbn-config-preview]')||[]];
 const previewLabels=[...configRoot?.querySelectorAll('[data-crbn-config-preview-label]')||[]];
 const vehicleSelect=selects.find(select=>select.dataset.label==='Vehicle');
 const tierMap=new Map([...configurator.querySelectorAll('[data-crbn-tier-cents]')].map(node=>[Number(node.dataset.crbnTierCents||0),Number(node.dataset.variantId||0)]).filter(([cents,id])=>cents&&id));
 const dollarMap=new Map([...configurator.querySelectorAll('[data-crbn-dollar]')].map(node=>[Number(node.dataset.crbnDollar||0),Number(node.dataset.variantId||0)]).filter(([dollars,id])=>dollars&&id));
 const centMap=new Map([...configurator.querySelectorAll('[data-crbn-cent]')].map(node=>[Number(node.dataset.crbnCent||0),Number(node.dataset.variantId||0)]).filter(([cents,id])=>cents&&id));
 const totalPriceMapRoot=configurator.querySelector('[data-crbn-total-price-map]');
 const totalPriceMap=new Map([...configurator.querySelectorAll('[data-crbn-total-cents]')].map(node=>[Number(node.dataset.crbnTotalCents||0),Number(node.dataset.variantId||0)]).filter(([cents,id])=>cents&&id));
 const totalTierProduct=totalPriceMapRoot?.dataset.crbnTotalTierProduct||'';
 const base=Number(configurator.dataset.basePrice||0);
 const currency=configurator.dataset.currency||'USD';
 const embroidery=configurator.querySelector('[data-crbn-embroidery]');
 const horn=configurator.querySelector('[name="properties[Horn pad]"]');
 const carbonFinish=configurator.querySelector('[name="properties[Carbon finish]"]');
 const noCarbonMaterial=configurator.querySelector('[data-crbn-no-carbon-material]');
 const gripColor=configurator.querySelector('[name="properties[Grip color]"]');
 const gripCustom=configurator.querySelector('[data-crbn-grip-custom]');
 const gripColorPicker=configurator.querySelector('[data-crbn-grip-color-picker]');
 const gripDescription=configurator.querySelector('[data-crbn-grip-description]');
 const stitchColor=configurator.querySelector('[name="properties[Stitch color]"]');
 const stitchCustomPanel=configurator.querySelector('[data-crbn-stitch-custom-panel]');
 const stitchCustomMode=configurator.querySelector('[data-crbn-stitch-custom-mode]');
 const stitchColorPicker=configurator.querySelector('[data-crbn-stitch-color-picker]');
 const stitchDescription=configurator.querySelector('[data-crbn-stitch-description]');
 const stitchMatchTarget=configurator.querySelector('[data-crbn-stitch-match-target]');
 const stitchMatchGroup=configurator.querySelector('[data-crbn-stitch-match-group]');
 const stitchMatchReference=configurator.querySelector('[data-crbn-stitch-match-reference]');
 const stitchMatchFile=configurator.querySelector('[data-crbn-stitch-match-file]');
 const submit=configurator.querySelector('button[type="submit"]');
 const error=configurator.querySelector('[data-crbn-config-error]');
 const submitInitiallyDisabled=Boolean(submit?.disabled);
 let submitting=false;
 let previewRevision=0;

 const setError=message=>{
  if(!error)return;
  error.textContent=message||'';
  error.hidden=!message;
 };

 const priceFragments=(surcharge,label,value)=>{
  const parts=[];
  const invalid=()=>[{id:0,quantity:1,label,value,surcharge,priceMode:'missing',fragmentIndex:1,fragmentCount:1,fragmentCents:surcharge}];
  const add=(id,cents,priceMode)=>parts.push({id,cents,priceMode});
  const exactId=tierMap.get(surcharge);
  let remaining=surcharge;

  if(exactId){
   add(exactId,surcharge,'tier');
   remaining=0;
  }else{
   while(remaining>=50000){
    const id=tierMap.get(50000);
    if(!id)return invalid();
    add(id,50000,'flex-tier');
    remaining-=50000;
   }

   const tierCents=Math.floor(remaining/2500)*2500;
   if(tierCents){
    const id=tierMap.get(tierCents);
    if(!id)return invalid();
    add(id,tierCents,'flex-tier');
    remaining-=tierCents;
   }

   const dollars=Math.floor(remaining/100);
   if(dollars){
    const id=dollarMap.get(dollars);
    if(!id)return invalid();
    add(id,dollars*100,'flex-dollar');
    remaining-=dollars*100;
   }

   if(remaining){
    const id=centMap.get(remaining);
    if(!id)return invalid();
    add(id,remaining,'flex-cent');
    remaining=0;
   }
  }

  if(!parts.length||parts.reduce((sum,part)=>sum+part.cents,0)!==surcharge)return invalid();
  return parts.map((part,index)=>({
   id:part.id,
   quantity:1,
   label,
   value,
   surcharge,
   priceMode:part.priceMode,
   fragmentIndex:index+1,
   fragmentCount:parts.length,
   fragmentCents:part.cents
  }));
 };

 const selectedUpgrades=()=>selects.flatMap(select=>{
  const option=select.options[select.selectedIndex];
  const surcharge=Number(option?.dataset.priceAdd||0);
  if(!surcharge)return[];
  return priceFragments(surcharge,select.dataset.label||select.name,select.value);
 });

 const refresh=()=>{
  const showEmbroidery=horn?.value==='Custom embroidery';
  if(embroidery){
   const field=embroidery.closest('[data-crbn-embroidery-field],.crbn-field');
   if(field)field.hidden=!showEmbroidery;
   embroidery.disabled=!showEmbroidery;
   if(!showEmbroidery)embroidery.value='';
  }

  const showNoCarbonMaterial=carbonFinish?.value==='No carbon fiber';
  if(noCarbonMaterial){
   const field=noCarbonMaterial.closest('[data-crbn-no-carbon-material-field],.crbn-field');
   if(field)field.hidden=!showNoCarbonMaterial;
   noCarbonMaterial.disabled=!showNoCarbonMaterial;
  }

  const showGripCustom=gripColor?.value==='Custom color';
  [gripCustom,gripColorPicker,gripDescription].forEach(input=>{
   if(!input)return;
   const field=input.closest('.crbn-field');
   if(field)field.hidden=!showGripCustom;
   input.disabled=!showGripCustom;
   if(!showGripCustom&&input!==gripColorPicker)input.value='';
  });

  const showStitchCustom=stitchColor?.value==='Custom color';
  if(stitchCustomPanel)stitchCustomPanel.hidden=!showStitchCustom;
  if(stitchCustomMode)stitchCustomMode.disabled=!showStitchCustom;
  const stitchMode=showStitchCustom?(stitchCustomMode?.value||'Pick color'):'';
  const showStitchPicker=showStitchCustom&&stitchMode==='Pick color';
  if(stitchColorPicker){
   const field=stitchColorPicker.closest('.crbn-field');
   if(field)field.hidden=!showStitchPicker;
   stitchColorPicker.disabled=!showStitchPicker;
  }
  const showStitchDescription=showStitchCustom&&stitchMode==='Describe color';
  if(stitchDescription){
   const field=stitchDescription.closest('.crbn-field');
   if(field)field.hidden=!showStitchDescription;
   stitchDescription.disabled=!showStitchDescription;
   if(!showStitchDescription)stitchDescription.value='';
  }

  const showStitchMatch=showStitchCustom&&stitchMode==='Color match';
  if(stitchMatchGroup)stitchMatchGroup.hidden=!showStitchMatch;
  if(stitchMatchTarget)stitchMatchTarget.disabled=!showStitchMatch;
  const showStitchReference=showStitchMatch&&stitchMatchTarget?.value==='Reference';
  if(stitchMatchReference){
   const field=stitchMatchReference.closest('.crbn-field');
   if(field)field.hidden=!showStitchReference;
   stitchMatchReference.disabled=!showStitchReference;
   if(!showStitchReference)stitchMatchReference.value='';
  }
  if(stitchMatchFile){
   const field=stitchMatchFile.closest('.crbn-field');
   if(field)field.hidden=!showStitchReference;
   stitchMatchFile.disabled=!showStitchReference;
   if(!showStitchReference)stitchMatchFile.value='';
  }

  let add=0;
  selects.forEach(select=>{
   const option=select.options[select.selectedIndex];
   add+=Number(option?.dataset.priceAdd||0);
  });
  const selectedValue=label=>selects.find(select=>select.dataset.label===label)?.value||'';
  const vehicle=selectedValue('Vehicle');
  const buildParts=[
   selectedValue('Carbon finish'),
   selectedValue('Grip material'),
   selectedValue('Stitch color')
  ].filter(Boolean);
  if(price)price.textContent=money(base+add,currency);
  if(summaryVehicle)summaryVehicle.textContent=vehicle;
  if(summary)summary.textContent=buildParts.join(' · ');
  if(summaryTotal)summaryTotal.textContent=`Configured total ${money(base+add,currency)}`;

  const vehicleOption=vehicleSelect?.options[vehicleSelect.selectedIndex];
  const nextPreview=vehicleOption?.dataset.crbnPreviewImage;
  if(nextPreview){
   previewLabels.forEach(label=>{label.textContent=vehicleOption.dataset.crbnPreviewLabel||vehicleOption.value;});
   const revision=++previewRevision;
   previewImages.forEach(image=>{
    if(image.src===nextPreview)return;
    image.classList.add('is-changing');
    setTimeout(()=>{
     if(revision!==previewRevision)return;
     image.src=nextPreview;
     image.alt=vehicleOption.dataset.crbnPreviewAlt||vehicleOption.value;
     requestAnimationFrame(()=>requestAnimationFrame(()=>image.classList.remove('is-changing')));
    },140);
   });
  }

  const configuredTotal=base+add;
  const totalVariantId=totalTierProduct==='custom-carbon-fiber-steering-wheel'&&totalPriceMap.size>1
   ? Number(totalPriceMap.get(configuredTotal)||0)
   : 0;
  const missing=totalVariantId?null:selectedUpgrades().find(upgrade=>!upgrade.id);
  if(missing){
   setError(`The ${missing.value} upgrade is temporarily unavailable. Please refresh or contact us.`);
   if(submit)submit.disabled=true;
  }else{
   setError('');
   if(submit)submit.disabled=submitInitiallyDisabled||submitting;
  }
 };

 selects.forEach(select=>select.addEventListener('change',refresh));
 embroidery?.addEventListener('input',refresh);
 noCarbonMaterial?.addEventListener('change',refresh);
 gripCustom?.addEventListener('input',refresh);
 gripColorPicker?.addEventListener('input',refresh);
 gripDescription?.addEventListener('input',refresh);
 refresh();

 if(!(configurator instanceof HTMLFormElement))return;

 configurator.addEventListener('submit',async event=>{
  event.preventDefault();
  event.stopImmediatePropagation();
  event.stopPropagation();
  if(submitting||configurator.dataset.crbnSubmitting==='true')return;

  const baseVariantId=Number(configurator.querySelector('[name="id"]')?.value||0);
  const configuredTotal=base+selects.reduce((sum,select)=>sum+Number(select.options[select.selectedIndex]?.dataset.priceAdd||0),0);
  const totalVariantId=totalTierProduct==='custom-carbon-fiber-steering-wheel'&&totalPriceMap.size>1
   ? Number(totalPriceMap.get(configuredTotal)||0)
   : 0;
  const upgrades=totalVariantId?[]:selectedUpgrades();
  if(!baseVariantId){
   setError('The base steering wheel variant could not be found. Please refresh and try again.');
   return;
  }
  const missing=upgrades.find(upgrade=>!upgrade.id);
  if(missing){
   setError(`The ${missing.value} upgrade is temporarily unavailable. Please refresh or contact us.`);
   return;
  }

  const group=configurationId();
  const referenceFile=stitchMatchFile?.files?.[0]||null;
  const hasReferenceFile=Boolean(referenceFile&&referenceFile.size>0);
  const properties={};
  for(const [key,value] of new FormData(configurator).entries()){
   if(typeof File!=='undefined'&&value instanceof File)continue;
   const match=key.match(/^properties\[(.+)\]$/);
   if(match&&String(value).trim())properties[match[1]]=String(value).trim();
  }
  properties._crbn_configuration=group;
  properties._crbn_parent_variant=String(baseVariantId);
  properties._crbn_line_role='base';

  let items;
  if(totalVariantId){
   properties._crbn_price_mode='total-tier';
   properties._crbn_configured_total_cents=String(configuredTotal);
   items=[{id:totalVariantId,quantity:1,properties}];
  }else{
   items=[{id:baseVariantId,quantity:1,properties}];
   upgrades.forEach(upgrade=>{
    const upgradeProperties={
     _crbn_configuration:group,
     _crbn_parent_variant:String(baseVariantId),
     _crbn_line_role:'upgrade',
     _crbn_price_mode:upgrade.priceMode,
     _crbn_surcharge_cents:String(upgrade.surcharge),
     _crbn_fragment_index:String(upgrade.fragmentIndex),
     _crbn_fragment_count:String(upgrade.fragmentCount),
     _crbn_fragment_cents:String(upgrade.fragmentCents),
     _crbn_upgrade:`${upgrade.label}: ${upgrade.value}`,
     _crbn_fragment_key:`${upgrade.label}:${upgrade.value}:${upgrade.fragmentIndex}`
    };
    if(upgrade.fragmentIndex===1)upgradeProperties.Upgrade=`${upgrade.label}: ${upgrade.value}`;
    items.push({id:upgrade.id,quantity:1,parent_id:baseVariantId,properties:upgradeProperties});
   });
  }

  submitting=true;
  configurator.dataset.crbnSubmitting='true';
  setError('');
  if(submit){
   submit.disabled=true;
   submit.setAttribute('aria-busy','true');
  }

  try{
   const sectionIds=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')]
    .map(node=>node.dataset.sectionId)
    .filter(Boolean))];
   let result;
   if(hasReferenceFile){
    const configuredVariantId=totalVariantId||baseVariantId;
    const baseFormData=new FormData(configurator);
    baseFormData.set('id',String(configuredVariantId));
    baseFormData.set('quantity','1');
    baseFormData.set('properties[_crbn_configuration]',group);
    baseFormData.set('properties[_crbn_parent_variant]',String(baseVariantId));
    baseFormData.set('properties[_crbn_line_role]','base');
    if(totalVariantId){
     baseFormData.set('properties[_crbn_price_mode]','total-tier');
     baseFormData.set('properties[_crbn_configured_total_cents]',String(configuredTotal));
    }
    if(!upgrades.length&&sectionIds.length){
     baseFormData.set('sections',sectionIds.join(','));
     baseFormData.set('sections_url',window.location.pathname);
    }
    const baseResponse=await fetch(`${shopRoot()}cart/add.js`,{
     method:'POST',
     headers:{'Accept':'application/json'},
     body:baseFormData
    });
    const baseResult=await baseResponse.json().catch(()=>({}));
    if(!baseResponse.ok)throw new Error(baseResult.description||baseResult.message||'Shopify could not upload the reference photo with this configuration.');
    result=baseResult;

    if(upgrades.length){
     const baseLine=Array.isArray(baseResult?.items)?baseResult.items[0]:baseResult;
     let baseKey=baseLine?.key||'';
     if(!baseKey){
      const cartState=await fetch(`${shopRoot()}cart.js`,{headers:{'Accept':'application/json'}}).then(response=>response.json()).catch(()=>({items:[]}));
      baseKey=cartState.items?.find(item=>item.properties?._crbn_configuration===group&&item.properties?._crbn_line_role==='base')?.key||'';
     }
     if(!baseKey)throw new Error('The reference photo uploaded, but Shopify could not link the priced upgrades. Please remove the item from your cart and try again.');
     const upgradeItems=items.slice(1).map(item=>{
      const {parent_id,...child}=item;
      return {...child,parent_line_key:baseKey};
     });
     const payload={items:upgradeItems};
     if(sectionIds.length){
      payload.sections=sectionIds;
      payload.sections_url=window.location.pathname;
     }
     const upgradeResponse=await fetch(`${shopRoot()}cart/add.js`,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(payload)
     });
     const upgradeResult=await upgradeResponse.json().catch(()=>({}));
     if(!upgradeResponse.ok){
      await fetch(`${shopRoot()}cart/change.js`,{
       method:'POST',
       headers:{'Content-Type':'application/json','Accept':'application/json'},
       body:JSON.stringify({id:baseKey,quantity:0})
      }).catch(()=>{});
      throw new Error(upgradeResult.description||upgradeResult.message||'The reference photo uploaded, but the priced upgrades could not be added. Please try again.');
     }
     result=upgradeResult;
    }
   }else{
    const payload={items};
    if(sectionIds.length){
     payload.sections=sectionIds;
     payload.sections_url=window.location.pathname;
    }
    const response=await fetch(`${shopRoot()}cart/add.js`,{
     method:'POST',
     headers:{'Content-Type':'application/json','Accept':'application/json'},
     body:JSON.stringify(payload)
    });
    result=await response.json().catch(()=>({}));
    if(!response.ok)throw new Error(result.description||result.message||'Shopify could not add this configuration to the cart.');
   }

   document.dispatchEvent(new CustomEvent('cart:update',{
    bubbles:true,
    detail:{
     resource:result,
     sourceId:group,
     data:{
      source:'product-form-component',
      itemCount:1,
      productId:String(baseVariantId),
      variantId:String(baseVariantId),
      sections:result.sections||{}
     }
    }
   }));

   setTimeout(()=>{
    const liveDrawer=document.querySelector('cart-drawer-component');
    if(!liveDrawer)return;
    if(typeof liveDrawer.open==='function'){
     liveDrawer.open();
     return;
    }
    const dialog=liveDrawer.querySelector('dialog');
    if(dialog instanceof HTMLDialogElement&&!dialog.open){
     try{dialog.showModal();}catch(_){
      dialog.setAttribute('open','');
     }
    }
   },0);
   submitting=false;
   delete configurator.dataset.crbnSubmitting;
   if(submit){
    submit.disabled=submitInitiallyDisabled;
    submit.removeAttribute('aria-busy');
   }
  }catch(err){
   setError(err instanceof Error?err.message:'Something went wrong while adding this configuration.');
   submitting=false;
   delete configurator.dataset.crbnSubmitting;
   if(submit){
    submit.disabled=submitInitiallyDisabled;
    submit.removeAttribute('aria-busy');
   }
  }
 },{capture:true});
});

document.querySelectorAll('[data-crbn-product-gallery]').forEach(gallery=>{
 const main=gallery.querySelector('[data-crbn-main-image]');
 const buttons=[...gallery.querySelectorAll('[data-crbn-thumb]')];
 if(!main||!buttons.length)return;
 const cache=new Map();
 let swapToken=0;
 const preload=(url,priority='low')=>{
  if(!url)return Promise.resolve();
  if(cache.has(url))return cache.get(url);
  const task=new Promise(resolve=>{
   const image=new Image();
   image.decoding='async';
   try{image.fetchPriority=priority;}catch(_){ }
   image.onload=()=>{
    const decoded=typeof image.decode==='function'?image.decode().catch(()=>{}):Promise.resolve();
    decoded.finally(resolve);
   };
   image.onerror=resolve;
   image.src=url;
  });
  cache.set(url,task);
  return task;
 };
 const urls=[...new Set(buttons.map(button=>button.dataset.image).filter(Boolean))];
 const current=main.getAttribute('src')||'';
 const pending=urls.filter(url=>url!==current);
 pending.slice(0,2).forEach(url=>preload(url,'low'));
 const warmRest=()=>{
  let index=2;
  const next=()=>{
   if(index>=pending.length)return;
   preload(pending[index++],'low');
   if('requestIdleCallback' in window)window.requestIdleCallback(next,{timeout:1200});
   else setTimeout(next,90);
  };
  next();
 };
 if(document.readyState==='complete')setTimeout(warmRest,0);
 else window.addEventListener('load',()=>setTimeout(warmRest,0),{once:true});
 buttons.forEach(button=>{
  const url=button.dataset.image;
  button.addEventListener('pointerenter',()=>preload(url,'high'),{passive:true});
  button.addEventListener('focus',()=>preload(url,'high'));
  button.addEventListener('click',async()=>{
   if(!url)return;
   const token=++swapToken;
   buttons.forEach(item=>item.classList.toggle('is-active',item===button));
   await preload(url,'high');
   if(token!==swapToken)return;
   main.src=url;
   main.alt=button.dataset.alt||'';
   if(!reduced&&typeof main.animate==='function')main.animate([{opacity:.82},{opacity:1}],{duration:140,easing:'ease-out'});
  });
 });
});
})();
